<button
  nz-button
  nzSize="small"
  nz-popover
  nzPopoverTrigger="click"
  [(nzPopoverVisible)]="showPopover"
  [nzPopoverTitle]="changeStartPricePopoverTitle"
  [nzPopoverContent]="changeStartPricePopoverBody"
  (nzPopoverVisibleChange)="showPopover = $event"
>
  <i nz-icon nzType="edit" nzTheme="outline"></i>
</button>

<ng-template #changeStartPricePopoverTitle>
  <nz-row nzJustify="space-between">
    <nz-col>{{ 'LOT_INFO.START_PRICE' | translate }}</nz-col>
    <nz-col>
      <i nz-icon class="pointer" nzType="close" nzTheme="outline" (click)="showPopover = false"></i>
    </nz-col>
  </nz-row>
</ng-template>

<ng-template #changeStartPricePopoverBody>
  <section>
    <nz-input-number
      [(ngModel)]="startPriceValue"
      [nzMin]="1"
      [nzStep]="10000"
      nzSize="small"
    ></nz-input-number>
  </section>
  <section>
    <button
      nz-button
      nzSize="small"
      nzType="primary"
      [nzLoading]="saving | async"
      (click)="saveStartPrice()"
    >
      {{ 'SAVE' | translate }}
    </button>
  </section>
</ng-template>
